import React from 'react';
import PenziLegalLayout, { isPenziDomain } from '../components/PenziLegalLayout.js';

// Original, general website terms; separate from the existing Terms page.
export default function TermsAndConditions() {
    const service = isPenziDomain() ? 'Penzi Halisi' : 'this platform';
    return (
        <PenziLegalLayout>
            <div className="mx-auto max-w-4xl p-6 text-gray-700">
                <h1 className="text-4xl font-bold mb-6">Terms and Conditions</h1>
                <p className="mb-8">These general terms explain the basic rules for using {service}. By using the website, you agree to these terms. If you do not agree, please do not use the service.</p>
                <section>
                    <h2 className="text-2xl font-semibold mb-4">1. Eligibility and your account</h2>
                    <p>You must be at least 18 years old to use the service. Provide accurate information, keep your login details private, and use only an account you are authorised to access.</p>
                </section>
                <section>
                    <h2 className="text-2xl font-semibold mb-4">2. Respectful use</h2>
                    <p>Treat other people respectfully. Do not use the service for harassment, impersonation, fraud, spam, unlawful activity, or sharing harmful content. Respect other members’ privacy and do not share their personal information without permission.</p>
                </section>
                <section>
                    <h2 className="text-2xl font-semibold mb-4">3. User Submissions & Diagnostic Input</h2>
                    <p>Users agree to submit accurate information and use our assessment tools for lawful personal purposes.</p>
                </section>
                <section>
                    <h2 className="text-2xl font-semibold mb-4">4. Paid services</h2>
                    <p>If you choose a paid service, review its price, features, duration, and any cancellation or refund conditions shown before you pay. These general terms do not replace any specific purchase terms presented to you.</p>
                </section>
                <section>
                    <h2 className="text-2xl font-semibold mb-4">5. Privacy</h2>
                    <p>Our <a href="/privacypolicy">Privacy Policy</a> explains how personal information is handled. Please read it before sharing your information.</p>
                </section>
                <section>
                    <h2 className="text-2xl font-semibold mb-4">6. Availability and responsibility</h2>
                    <p>Features may change, and the website may sometimes be unavailable for maintenance or other reasons. You are responsible for your own interactions and decisions. Nothing in these terms removes rights or responsibilities that cannot be excluded under applicable law.</p>
                </section>
                <section>
                    <h2 className="text-2xl font-semibold mb-4">7. Updates and questions</h2>
                    <p>We may update these terms by posting a revised version on this page. Please review them from time to time. For questions about the service or these terms, use the support options available on the website.</p>
                </section>
            </div>
        </PenziLegalLayout>
    );
}
